import PropTypes from "prop-types";
import React, { useEffect } from "react";

export const AddNotification = ({ message, type, onClose, show }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const notificationStyles = {
    success: "bg-teal-600",
    error: "bg-red-500",
    info: "bg-blue-500",
    warning: "bg-yellow-500",
  };

  return (
    <div
      className={`fixed top-0 left-1/2 transform -translate-x-1/2 z-50 transition-all p-4 space-y-2 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[-50px]"
      }`}
    >
      <div
        className={`max-w-sm w-full p-4 mb-4 text-white rounded-lg shadow-lg ${notificationStyles[type]} flex items-center justify-between`}
      >
        <span>{message}</span>
        <button
          onClick={onClose}
          className="ml-4 text-xl font-semibold hover:text-gray-200"
        >
          &times;
        </button>
      </div>
    </div>
  );
};

AddNotification.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  show: PropTypes.bool,
};
